import { TimeReport, TimeReportProject } from "../types";

export const transformTimeReportProject = (
  timeReport: TimeReport,
  projectGuid: string,
  transformProject: (currentProject: TimeReportProject) => TimeReportProject,
): TimeReport => {
  const projectIdx = timeReport.projects.findIndex(pr => pr.project.guid === projectGuid);

  if (projectIdx >= 0) {
    return {
      ...timeReport,
      projects: timeReport.projects.map((currentProject, idx) =>
        idx === projectIdx ? transformProject(currentProject) : currentProject,
      ),
    };
  }

  return { ...timeReport };
};
